import Swiper, { Navigation, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";

const swiper = new Swiper(".swiper", {
	modules: [Navigation, Autoplay],
	loop: true,
	speed: 700,
	slidesPerView: 1.000001,
	centeredSlides: true,
	spaceBetween: 49,
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	breakpoints: {
		//     1040: {
		//         spaceBetween: 49,
    //      },
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});
